
export { LoggerEvents } from "/app/libs/core/src/application-insights.ts"
export { appInsights } from "/app/libs/core/src/application-insights.ts"